import BaseService from "./BaseService";

/**
 * Service class for interacting with the 'organization' resource in the API.
 * Extends the BaseService class.
 */
class SessionService extends BaseService {
  /**
   * The resource endpoint for the 'organization' service.
   * @type {string}
   */
  resource = "session";

  /**
   * Fetches all items from the specified resource.
   * @returns {Promise} A Promise that resolves to the response data.
   */
  async readAll() {
    const { sessionsList: sessions } = await this.api.get(
      // `/${this.resource}?organization=deepstone&channel=["chat","telegram"]`,
      // `/${this.resource}/66570168d8aa89f9059a05eb`,
    );

    return { sessions };
  }

  /**
   * Fetches available sessions based on the given filter parameters.
   * @param {string} organization - Filter by organization's sessions.
   * @param {array} channels - Sessions channel types.
   * @param {string} sessionId - Session id.
   * @param {string} message - Sessions where history contains the message.
   * @param {string} date - Sessions where history contains at least one message in the date.
   * @returns {Promise} A Promise that resolves to the response data.
   */
  async read(query) {
    let request = `/${this.resource}${query}`
    const sessionsList = await this.api.get(request);
    return sessionsList;
  }
}

const sessionServiceInstance = new SessionService();

export default sessionServiceInstance;
